"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTag = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.ListTag = function (_a) {
    var children = _a.children, rest = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement(StyledLabel, tslib_1.__assign({}, rest), children));
};
var StyledLabel = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  background-color: ", ";\n  margin-left: 0.8rem;\n  font-size: 0.9rem;\n  padding: 0rem 0.4rem;\n  line-height: 1.5rem;\n  border-radius: 0.1rem;\n  align-self: center;\n  font-family: ", ";\n"], ["\n  display: inline-flex;\n  background-color: ", ";\n  margin-left: 0.8rem;\n  font-size: 0.9rem;\n  padding: 0rem 0.4rem;\n  line-height: 1.5rem;\n  border-radius: 0.1rem;\n  align-self: center;\n  font-family: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[100];
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
});
var templateObject_1;
